import {CHART_PALETTE} from './CHART_PALETTE';

/**
 * Hue of each calculation type and of their total. Every aftersales chart uses the same hues,
 * so a reader who learns that labour is blue reads every report that way.
 */
export const CALCULATION_TYPE_HUES = {
  labour: CHART_PALETTE.blue,
  material: CHART_PALETTE.green,
  dmm: CHART_PALETTE.orange,
  total: CHART_PALETTE.purple,
} as const;
